import React from 'react';
import { AppStoreImage, AppStoreLink } from './StoreLogos.styled';

export const AppStoreLogo = () => (
  <AppStoreLink href="https://apps.apple.com/us/app/aula-classroom-communication/id909131134?itsct=apps_box_badge&amp;itscg=30200">
    <AppStoreImage alt="Download on the App Store" />
  </AppStoreLink>
);
